import React, { useContext, useState, useEffect } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import { IGetModifierInfoV2 } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getModifierInfoV2, updateRestaurantsInModifier } from 'backend/modifiers';
import { ModalContent } from 'components/ModalWindows/ModalContent';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import Text from 'components/Text/Text';
import { RestaurantMultipleSelect } from './RestaurantMultipleSelect';

interface IProps {
	onCloseModal: () => void;
	onFailureEvent?: () => void;
	onShowError: () => void;
	modifierId: string;
}

export const ModalAssignModifierToRestaurants: React.FC<IProps> = ({
	onCloseModal,
	onFailureEvent,
	onShowError,
	modifierId,
}) => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const [selectedRestaurants, setSelectedRestaurants] = useState<string[]>([]);
	const { response, loading } = useFetchData<IGetModifierInfoV2, string>(getModifierInfoV2, modifierId);

	useEffect(() => {
		loading ? showLoader() : hideLoader();
	}, [loading]);

	useEffect(() => {
		if (response) {
			setSelectedRestaurants(response.data.restaurants.map((restaurant) => restaurant.id));
		}
	}, [response]);

	const handleAssignRestaurants = async () => {
		try {
			showLoader();
			await updateRestaurantsInModifier({
				modifierId,
				restaurantIds: selectedRestaurants,
			});
			onCloseModal();
		} catch (err) {
			onShowError();
		} finally {
			hideLoader();
		}
	};

	return (
		<ModalContent
			onConsentEvent={handleAssignRestaurants}
			onFailureEvent={onFailureEvent ? onFailureEvent : onCloseModal}
			heading="attachedRestaurants"
			headerTranslationNameSpace="listing"
			translationOfConfirmBtn="saveButton"
			headingAlignment="left"
			centered={false}>
			<FullInfoField label="customerLabel" />
			<Text translationKey={response?.data.customer.name} size="s" />
			<RestaurantMultipleSelect
				setSelectedRestaurants={setSelectedRestaurants}
				selectedRestaurants={selectedRestaurants}
				customerID={response?.data.customer.id}
			/>
		</ModalContent>
	);
};
